import React, { useEffect, useState } from "react";
import brochure1 from "../../../../image/brochure 1.png";
import signum from "../../../../image/signum.jpg";
import zylusPrime from "../../../../image/zylus-prime.jpg";
import zylusprime1 from "../../../../image/zylusprime1.jpg";
import zylusprime2 from "../../../../image/zylusprime2.jpg";
import zylusprime3 from "../../../../image/zylusprime3.jpg";
import signum2 from "../../../../image/signum2.jpg";
import signum3 from "../../../../image/signum3.jpg";
import signum4 from "../../../../image/signum4.jpg";
import sigmuNowSelling from "../../../../image/sigmuNowSelling.jpg";
// import faq from "../../../../image/SIGNUMPDF.pdf ";
import { BsPlayCircle } from "react-icons/bs";
import { IoCall } from "react-icons/io5";
import singleLand from "./Land-Houses.module.scss";
import { Form, Row, Col } from "react-bootstrap";
import { Modal, Button } from "react-bootstrap";
import { db } from "../../../firebase-config";
import { collection, addDoc } from "firebase/firestore";
import SucceesModal from "../../../modal/success-modal";

function SIngleLand12(props) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [switchs2, setSwitchs2] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [load, setLoad] = useState(false);
  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [social, setSocial] = useState("");
  const [category, setCategory] = useState("");
  const contactCollectionRef = collection(db, "reservations");
  const current = new Date();

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoad(true);
    addDoc(contactCollectionRef, {
      fullName: fullName,
      phone: phone,
      email: email,
      social: social,
      category: category,
      date: `${current.getDate()}/${
        current.getMonth() + 1
      }/${current.getFullYear()}`,
      read: false,
    })
      .then(() => {
        setLoad(false);
        setModalShow(true);
        setFullName("");
        setPhone("");
        setEmail("");
        setCategory("");
        setSocial("");
      })
      .catch((error) => {
        alert("Error occurred", error);
        setLoad(false);
      });
  };

  const [show1, setShow1] = useState(false);

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const clickMe2 = (index) => {
    setSwitchs2(index);
  };

  useEffect(() => {
    const ifameData = document.getElementById("iframeId");
    const lat = 6.440065356936118;
    const lon = 3.464997996111175;
    ifameData.src = `https://maps.google.com/maps?q=${lat},${lon}&hl=es;&output=embed`;
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className={singleLand.holdALl}>
      <div>
        <div className={singleLand.holdImage}>
          <div className={singleLand.holdImage2}>
            <img src={zylusPrime} alt="ZylusImage" />
            <div className={singleLand.holdPlayButin}>
              <a
                href={require("../../../../image/lekki avana brochure.09b671211b72e4f8c7f5.pdf")}
                target="_blank"
                download
                rel="noreferrer"
              >
                <button className={singleLand.holdPlayInee}>
                  <img src={brochure1} alt="ZylusImage" />
                  Download Brochure
                </button>
              </a>
              <button
              // onClick={handleShow}
              >
                <BsPlayCircle />
                Play Video
              </button>
              <a
                href={require("../../../../image/LEKKI AVANA FORM AND FAQ.0c9b9ef15958a4b9d531.pdf")}
                download
                target="_blank"
                rel="noreferrer"
              >
                <button className={singleLand.holdPlayInee}>
                  <img src={brochure1} alt="ZylusImage" />
                  Download FAQ
                </button>
              </a>
            </div>
          </div>
        </div>
        <div className={singleLand.holdApartment}>
          <div className={singleLand.holdApartment2}>
            <div className={singleLand.holdBedroom2}>
              <img src={zylusPrime} alt="Rectangle31" />
            </div>
            <div className={singleLand.holdBedroom}>
              <h1>Zylus Prime City</h1>
              <p className={singleLand.SQM}>500 SQM & 300 SQM</p>
              <div>
                <h4>Location</h4>
                <p>Eleran Igbe Bus stop</p>
              </div>
              <div>
                <h4>Overview</h4>
                <p>
                  It’s time to step into a world where every moment holds the
                  promise of a brighter future
                </p>
                <p>
                  Zylus Prime City is more than just a real estate development;
                  it’s a thriving community designed for those who desire
                  premium living and profitable investments.{" "}
                </p>
                <h4>NOW SELLING AT PROMO PRICE</h4>
                <p>300SQM AT 15MILLION INSTEAD OF 18MILLION</p>
                <p>500SQM AT 25MILLION INSTEAD OF 30MILLION</p>
                <h4>INITIAL DEPOSIT</h4>
                <p>2 Million naira</p>
                <h4>WHAT YOU NEED TO KNOW ABOUT ZYLUS PRIME CITY</h4>
                <p>
                  The estate is in a very strategic location right at Eleran
                  Igbe Bus stop.
                </p>
                <p>The estate is government allocation.</p>
                <p>The title is Government Allocation </p>
                <p>
                  Allocation can be verified and confirmed at Land Registry,
                  NTDA and Surveyor General Officce.
                </p>
                <p>
                  Close to Lekki International Airport and other huge government
                  and private business landmark in the Lekki Epe corridor.
                </p>
                <p>
                  Close to the popular Tiwa Garden Phase 2 and Tiwa Commercial
                  Hub.
                </p>
                <p>
                  The estate has unique features that opens up world of
                  possibilities for you.
                </p>
                <p>
                  If you desire serenity, security, and sophistication in one of
                  Lagos' fastest-growing locations this is a perfect estate for
                  you.
                </p>
                <p>
                  Secure your piece of the future today and step into a world
                  where dreams become reality!
                </p>
              </div>
            </div>
          </div>
          <div className={singleLand.holdSMallImage}>
            <div className={singleLand.holdSMallImage2}>
              <div>
                <img
                  src={zylusprime1}
                  alt="Rectangle31"
                  style={{ height: "400px" }}
                />
              </div>
              <div>
                <img
                  src={zylusprime2}
                  alt="Rectangle31"
                  style={{ height: "400px" }}
                />
              </div>
              <div>
                <img
                  src={zylusprime3}
                  alt="Rectangle31"
                  style={{ height: "400px" }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className={singleLand.holdViewPaymentPlan}>
          <div className={singleLand.holdViewPaymentPlan2}>
            <h1>Zylus Prime City</h1>
            <div className={singleLand.holdViewCityPricing}>
              <div className={singleLand.holdViewCityPricing2}>
                <div className={singleLand.holdViewCityPricing3}>
                  <h1>Zylus Prime City</h1>
                  <p>Land title:(Certificate of Occupancy)</p>
                  <h5>300 Square Meters</h5>
                  <div>
                    <h5>₦15,000,000</h5>
                    <p>Initial price: N3,000,000</p>
                  </div>
                </div>
                <div className={singleLand.holdViewPaymentPlanMN}>
                  <button onClick={handleShow1}>View Payment Plan</button>
                </div>
              </div>
              <div className={singleLand.holdViewCityPricing2}>
                <div className={singleLand.holdViewCityPricing3}>
                  <h1>Zylus Prime City</h1>
                  <p>Land title:(Government Allocation)</p>
                  <h5>500 Square Meters</h5>
                  <div>
                    <h5>₦25,000,000</h5>
                    <p>Initial price: N3,000,000</p>
                  </div>
                </div>
                <div className={singleLand.holdViewPaymentPlanMN}>
                  <button onClick={handleShow1}>View Payment Plan</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={singleLand.holdLekkiPrideIEstateM}>
          <div className={singleLand.holdLekkiPrideIEstate2M}>
            <h4>Make your Reservation</h4>
            <div className={singleLand.holdLekkiPrideIEstate2M2}>
              <div className={singleLand.holdForm}>
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="formGridAddress1">
                    <Form.Label>Full Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Full Name"
                      style={{ border: "2px solid #ffcc29" }}
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                      required
                    />
                  </Form.Group>
                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="formGridEmail">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter email"
                        style={{ border: "2px solid #ffcc29" }}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </Form.Group>

                    <Form.Group as={Col} controlId="formGridPassword">
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Phone Number"
                        style={{ border: "2px solid #ffcc29" }}
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        required
                      />
                    </Form.Group>
                  </Row>

                  <Form.Group
                    as={Col}
                    className="mb-3"
                    controlId="formGridState"
                  >
                    <Form.Label>How did you hear about us?</Form.Label>
                    <Form.Select
                      defaultValue=""
                      style={{ border: "2px solid #ffcc29" }}
                      value={social}
                      onChange={(e) => setSocial(e.target.value)}
                      required
                    >
                      <option></option>
                      <option>Linkedin</option>
                      <option>Instagram</option>
                      <option>Facebook</option>
                      <option>Twitter</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group
                    as={Col}
                    className="mb-3"
                    controlId="formGridState"
                  >
                    <Form.Label>Are you working with a Realtor</Form.Label>
                    <Form.Select
                      defaultValue=""
                      style={{ border: "2px solid #ffcc29" }}
                      value={category}
                      onChange={(e) => setCategory(e.target.value)}
                      required
                    >
                      <option></option>
                      <option>Yes</option>
                      <option>No</option>
                    </Form.Select>
                  </Form.Group>

                  <button className={singleLand.formButton}>
                    {load ? "Please wait..." : "Submit"}
                  </button>
                </Form>
              </div>
              <div className={singleLand.holdMap}>
                <iframe
                  id="iframeId"
                  title="Map"
                  className={singleLand.mapKoko}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
        <div className={singleLand.holdAnytime}>
          <div>
            <h1 className={singleLand.Reach}>You Can Reach Us Anytime</h1>
            <p className={singleLand.question}>
              Have a question or doubt about our property?
            </p>
          </div>
          <button className={singleLand.callUs}>
            <IoCall />
            Call us
          </button>
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h5>Signum</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe
            width="100%"
            height="300px"
            src="https://www.youtube.com/embed/yI4fbeAkAR8?si=0acMRkxUROVw20K4"
            // src="https://www.youtube.com/embed/DHBR6ptKuc0"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={show1} onHide={handleClose1} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Payment Plan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={singleLand.holdAllPriceLand1}>
            <div className={singleLand.holdAllPriceLand2}>
              <div className={singleLand.holdButin}>
                <button
                  type="button"
                  className={
                    switchs2 === 0 ? singleLand.meter : singleLand.outMeter
                  }
                  onClick={() => {
                    clickMe2(0);
                  }}
                >
                  500 SQM
                </button>
                {/* <button
                  type="button"
                  className={
                    switchs2 === 1 ? singleLand.meter : singleLand.outMeter
                  }
                  onClick={() => {
                    clickMe2(1);
                  }}
                >
                  417 SQM
                </button> */}
                <button
                  type="button"
                  className={
                    switchs2 === 2 ? singleLand.meter : singleLand.outMeter
                  }
                  onClick={() => {
                    clickMe2(2);
                  }}
                >
                  300 SQM
                </button>
                {/* <button
                  type="button"
                  className={
                    switchs2 === 3 ? singleLand.meter : singleLand.outMeter
                  }
                  onClick={() => {
                    clickMe2(3);
                  }}
                >
                  250 SQM
                </button> */}
              </div>
              <div
                className={
                  switchs2 === 0
                    ? singleLand.display + singleLand.holdListMe2
                    : singleLand.notDisplay
                }
                style={{ width: "100%" }}
              >
                <div className={singleLand.holdTableMeNow}>
                  <table>
                    <thead>
                      <tr>
                        <th>Months</th>
                        <th>Amount</th>
                        <th>Initial Deposit</th>
                        <th>Monthly Payment</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>0 - 3 month</td>
                        <td>N25,000,000</td>
                        <td>N2,000,000</td>
                        <td>N7,666,667</td>
                      </tr>
                      <tr>
                        <td>0 - 4 month</td>
                        <td>N26,000,000</td>
                        <td>N2,000,000</td>
                        <td>N4,000,000</td>
                      </tr>
                      <tr>
                        <td>7 - 12 month</td>
                        <td>N27,000,000</td>
                        <td>N2,000,000</td>
                        <td>N2,083,000</td>
                      </tr>
                      <tr>
                        <td>13 - 18 month</td>
                        <td>N29,000,000</td>
                        <td>N2,000,000</td>
                        <td>N1,500,000</td>
                      </tr>
                      <tr></tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                className={
                  switchs2 === 1
                    ? singleLand.display + singleLand.holdListMe2
                    : singleLand.notDisplay
                }
                style={{ width: "100%" }}
              >
                <div className={singleLand.holdTableMeNow}>
                  <table>
                    <thead>
                      <tr>
                        <th>Months</th>
                        <th>Amount</th>
                        <th>Initial Deposit</th>
                        <th>Monthly Payment</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>0 - 3 month</td>
                        <td>N23,000,000</td>
                        <td>N3,000,000</td>
                        <td>N7,000,000</td>
                      </tr>
                      <tr>
                        <td>0 - 4 month</td>
                        <td>N24,000,000</td>
                        <td>N3,000,000</td>
                        <td>N3,666,666</td>
                      </tr>
                      <tr>
                        <td>7 - 12 month</td>
                        <td>N25,000,000</td>
                        <td>N3,000,000</td>
                        <td>N1,916,666</td>
                      </tr>
                      <tr>
                        <td>13 - 18 month</td>
                        <td>N26,500,000</td>
                        <td>N3,000,000</td>
                        <td>N1,333,333</td>
                      </tr>
                      <tr></tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                className={
                  switchs2 === 2
                    ? singleLand.display + singleLand.holdListMe2
                    : singleLand.notDisplay
                }
                style={{ width: "100%" }}
              >
                <div className={singleLand.holdTableMeNow}>
                  <table>
                    <thead>
                      <tr>
                        <th>Months</th>
                        <th>Amount</th>
                        <th>Initial Deposit</th>
                        <th>Monthly Payment</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>0 - 3 month</td>
                        <td>N15,000,000</td>
                        <td>N2,000,000</td>
                        <td>N4,333,333</td>
                      </tr>
                      <tr>
                        <td>0 - 4 month</td>
                        <td>N16,000,000</td>
                        <td>N2,000,000</td>
                        <td>N2,333,333</td>
                      </tr>
                      <tr>
                        <td>7 - 12 month</td>
                        <td>N17,000,000</td>
                        <td>N2,000,000</td>
                        <td>N1,250,000</td>
                      </tr>
                      <tr>
                        <td>13 - 18 month</td>
                        <td>N19,000,000</td>
                        <td>N2,000,000</td>
                        <td>N944,444</td>
                      </tr>
                      <tr></tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                className={
                  switchs2 === 3
                    ? singleLand.display + singleLand.holdListMe2
                    : singleLand.notDisplay
                }
                style={{ width: "100%" }}
              >
                <div className={singleLand.holdTableMeNow}>
                  <table>
                    <thead>
                      <tr>
                        <th>Months</th>
                        <th>Amount</th>
                        <th>Initial Deposit</th>
                        <th>Monthly Payment</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>0 - 3 month</td>
                        <td>N13,500,000</td>
                        <td>N2,000,000</td>
                        <td>N3,833,333</td>
                      </tr>
                      <tr>
                        <td>0 - 4 month</td>
                        <td>N14,500,000</td>
                        <td>N2,000,000</td>
                        <td>N2,083,333</td>
                      </tr>
                      <tr>
                        <td>7 - 12 month</td>
                        <td>N15,500,000</td>
                        <td>N2,000,000</td>
                        <td>N1,125,000</td>
                      </tr>
                      <tr>
                        <td>13 - 18 month</td>
                        <td>N16,500,000</td>
                        <td>N2,000,000</td>
                        <td>N805,555</td>
                      </tr>
                      <tr></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <SucceesModal show={modalShow} onHide={() => setModalShow(false)} />
    </section>
  );
}

export default SIngleLand12;
